module.exports = __webpack_public_path__ + "static/media/CurrentOpenings2-banner.490e27aa.jpg";